
const userprofileview = [{"key":"userprofile.flash.ispublished","string":"Ihr Profil ist veröffentlicht."},{"key":"userprofile.flash.unpublish","string":"Klicken Sie hier um das Profil zu verbergen."},{"key":"userprofile.flash.isnotpublished","string":"Ihr Profil ist nicht veröffentlicht."},{"key":"userprofile.flash.publish","string":"Klicken Sie hier um es zu veröffentlichen."}]

export default userprofileview



// WEBPACK FOOTER //
// ./src/i18n/de/adduserprofile/userprofileview.js